<template>
  <div class="card yellow">
    <h2 class="card-h2"><span>Who</span></h2>
    <div class="card-content fetch" v-bind:class="[{'is-loading': isLoading}]">
      <div v-if="hasResults">
        <table class="yellow">
          <thead>
            <tr>
              <th>Metric</th>
              <th>Rank</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(ranking, index) in rankings" v-if="ranking !== null">
              <td><i class="material-icons">{{ labels[index].icon }}</i>  {{ labels[index].plural }}</td>
              <td>{{ ranking.rank }}{{ ranking.rank === 1 ? 'st' : '' }}{{ ranking.rank === 2 ? 'nd' : '' }}{{ ranking.rank === 3 ? 'rd' : '' }}{{ ranking.rank > 3 ? 'th' : '' }}</td>
              <td>{{ Number(ranking.amount).toLocaleString('en-US') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <p>No results that match those filters.</p>
      </div>
    </div>
    <div class="loader-dots-wrap center" v-bind:class="[{'is-loading': isLoading}]"><LoaderDots></LoaderDots></div>
  </div>
</template>

<script>
import LoaderDots from '@/components/LoaderDots'

let labels = {
  cyclists: {
    icon: 'directions_bike',
    plural: 'Cyclists involved'
  },
  hitparkedcar: {
    icon: 'local_parking',
    plural: 'Parked cars hit'
  },
  inattention: {
    icon: 'visibility_off',
    plural: 'Cases due to inattention'
  },
  pedestrians: {
    icon: 'directions_walk',
    plural: 'Pedestrians'
  },
  people: {
    icon: 'person',
    plural: 'People involved'
  },
  speeding: {
    icon: 'fast_forward',
    plural: 'Cases of speeding'
  },
  underinfl: {
    icon: 'blur_on',
    plural: 'Cases of driving under the influence'
  },
  vehicles: {
    icon: 'directions_car',
    plural: 'Vehicles involved'
  }
}

export default {
  name: 'whoRank',

  props: {
    'getters': {
      type: Object,
      required: true
    }
  },

  components: {
    'LoaderDots': LoaderDots
  },

  data: function () {
    return {
      labels: labels
    }
  },

  computed: {
    hasResults () {
      return (this.rankings[0] === -1) ? 0 : 1
    },

    isLoading () {
      return (Object.keys(this.rankings).length === 0) ? 1 : 0
    },

    rankings () {
      return this.$store.getters[this.getters.rankings]
    }
  }
}
</script>

<style lang="scss">
@import "./src/sass/components/who";
</style>



// WEBPACK FOOTER //
// WhoRank.vue?38894e8f